export enum ModerationStatus {
  None = 0,
  Accepted = 1,
  Declined = -1,
  NeedsModeration = 2,
}
